import type { ProcessStatsNativeModule } from "#process-stats-types";

// Web / Node / Jest: there is no process to inspect from a browser tab, so the native counters
// are absent. The diagnostics recorder still records the JS-side signals on web.
export const nativeProcessStats: ProcessStatsNativeModule | null = null;
